$.fn.Opportunite = function() {
  let self = this

  if (self.data('opportunite')) {
    return self.data('opportunite')
  }

  self.read_more_button = self.find('.opportunite__read-more')
  self.main_card = self.find('.opportunite__main')

  self.read_more_clicked = function() {
    let initialHeight = self.main_card.outerHeight(false)
    self.main_card.css('max-height', 'none')
    let targetHeight = self.main_card.outerHeight(false)
    self.main_card.css('height', initialHeight + 'px').addClass('opportunite__main--opened')
    requestAnimationFrame(function() {
      self.main_card.animate({
        'height': targetHeight + 'px',
      }, 350, 'easeInOutQuart', function() {
        self.css({
          'height': '',
          'max-height': '',
        })
      })
    })
  }

  return function() {
    self.data('opportunite', self)
    self.read_more_button.on('click', self.read_more_clicked)
    return self
  }()
}
